import type {CSSProperties} from 'react';
import {useEffect, useState} from 'react';
import {Box, Skeleton} from '@mui/material';

type CustomImageType = {
  url: string;
  styleProps?: CSSProperties;
  alt: string;
  height: number | string;
  width: number | string;
};

const CustomImage = ({
  styleProps,
  url,
  alt,
  height,
  width,
}: CustomImageType) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    let didCancel = false;
    const lowResUrl = `${url}`;

    const img = new Image();
    img.src = lowResUrl;

    if (img.complete) {
      !didCancel && setLoaded(true);
    } else {
      img.onload = () => !didCancel && setLoaded(true);
      img.onerror = () => !didCancel && setError(true);
    }

    return () => {
      didCancel = true;
    };
  }, [url]);

  return (
    <Box sx={{position: 'relative', width, height, ...styleProps}}>
      {!error && (
        <>
          {!loaded && (
            <Skeleton
              variant="rectangular"
              width={width}
              height={height}
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: 1,
                opacity: loaded ? 0 : 1,
                transition: 'opacity 0.3s ease-in-out',
                borderRadius: styleProps?.borderRadius || 0,
              }}
            />
          )}

          <img
            src={url}
            alt={alt}
            height={height}
            width={width}
            loading="lazy"
            style={{
              display: 'block',
              width,
              height,
              opacity: loaded ? 1 : 0,
              transition: 'opacity 0.4s ease-in-out',
              ...styleProps,
            }}
          />
        </>
      )}
    </Box>
  );
};

export default CustomImage;
